export {
  STORE_VISUAL_TEMPLATES_PATH,
  VISUAL_TEMPLATE_PARSER_TYPE,
} from "./store-path.constants.js";
// TODO get rid of constnants that are only used in one place

export { DROPPABLE_ATTRIBUTE } from "./user-events.constants.js";
